<template>
  <div class="articleLists clearfix">
    <div
      class="articleBox"
      v-for="(item, i) in list"
      :key="i"
      @click="gotoActivityDetail(item.id)"
    >
      <div class="imgBox" v-if="getImage(item)">
        <img
          class="imgs"
          :src="getImage(item) | imageUrl('', 510, 288, '', 'gif')"
          alt
        />
      </div>
      <div v-else class="imgBox">
        <img
          class="deflautImg"
          src="/static/newSearch/article_img_empty@2x.png"
          alt
        />
      </div>
      <p class="title">{{ item.title }}</p>
      <p class="content" v-html="delStyleTag(item.content)"></p>
      <div class="name" @click.stop.prevent="gotopeople(item.userId)">
        <img
          class="icon"
          :src="
            item.avatar | imageUrl('/static/profile_img_default.png', 40, 40)
          "
          alt=""
        />{{ item.nickName }}
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "articleLists",
  data() {
    return {};
  },
  methods: {
    delStyleTag(str) {
      return str
        .replace(/<style((?!<\/style>).)*<\/style>/g, "")
        .replace(/<style((?!<\/style>).)*<\/style>/g, "")
        .replace(/<[^>]+>/g, "");
    },
    gotoActivityDetail(id) {
      let routeData = this.$router.resolve({
        path: "/article/detail/" + id,
      });
      window.open(routeData.href, "_blank");
    },
    gotopeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home",
      });
      window.open(routeData.href, "_blank");
    },
    getImage(item) {
      let src = "";
      const imageList = item.content.match(/<img[^>]*>/);
      if (imageList && imageList.length) {
        imageList[0].replace(/ src="([^"]*)"/, (a, b) => (src = b));
      }
      return src;
    },
  },
  props: {
    list: Array,
  },
  created() {},
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.articleLists {
  width: 1110px;

  .articleBox {
    width: 255px;
    float: left;
    margin-right: 30px;
    cursor: pointer;

    &:nth-child(4) {
      margin-right: 0;
    }

    .imgBox {
      width: 255px;
      height: 144px;
      background: #f5f5f5;
      position: relative;
      left: -1px;
      .imgs {
        width: 100%;
        height: 100%;
      }

      .deflautImg {
        width: 64px;
        height: 64px;
        margin-top: 40px;
      }
    }

    .title {
      height: 21px;
      font-size: 14px;
      font-weight: bold;
      color: #0A0A0A;
      line-height: 21px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin: 10px 0 8px 0;
    }

    .content {
      min-height: 18px;
      font-size: 12px;
      font-weight: 400;
      color: #999999;
      line-height: 18px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
      margin-bottom: 8px;
    }

    .name {
      font-size: 12px;
      font-weight: 400;
      color: #666666;

      &:hover {
        color: #0A0A0A;
      }

      .icon {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/articleLists.vue